import React, { CSSProperties } from 'react'
import parsePhoneNumber from 'libphonenumber-js'

// Styles
import './styles.scss'

// Icons
import IconEdit from './images/iconEdit'
import { ExternalProfileType } from '../../containers/SignInPage/types'

export default ({
  style,
  profile,
}: {
  style?: CSSProperties
  profile: ExternalProfileType
}) => {
  const { REACT_APP_SSO_DOMAIN } = process.env

  const formatPhone = (phone: string) => {
    const format = parsePhoneNumber(phone, 'RU')?.formatNational()
    return `+7${format?.substr(1)}`
  }

  return (
    <div style={style} className={'contacts-edit-block'}>
      <div className={'contacts-edit-block__title'}>
        <div className={'title'}>Контактные данные</div>
        <a
          href={`https://${REACT_APP_SSO_DOMAIN}`}
          target={'_blank'}
          rel="noreferrer"
        >
          <IconEdit />
        </a>
      </div>
      <div className={'contacts-edit-block__column'}>
        <div className={'field'}>
          <div className={'field__label'}>E-mail:</div>
          <input disabled={true} value={profile.email} />
        </div>
        <div className={'field'}>
          <div className={'field__label'}>Телефон:</div>
          <input
            disabled={true}
            value={profile.phone_raw ? formatPhone(profile.phone_raw) : ''}
          />
        </div>
      </div>
    </div>
  )
}
